export default __webpack_public_path__ + "static/media/overtime.70b12f56.png";